export default "__VITE_ASSET__aa2d6166__"